import { render, staticRenderFns } from "./quote-customer.vue?vue&type=template&id=bf51b9a0&"
import script from "./quote-customer.vue?vue&type=script&lang=js&"
export * from "./quote-customer.vue?vue&type=script&lang=js&"
import style0 from "./quote-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports